import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { orgLinkPrefix } from "healthex-common/utils";
import { Navigate, Outlet } from "react-router";
import { getObservableT } from "../Infra/i18next";
import { AccountSettingsAboutYourOrgView } from "./AccountSettingsAboutYourOrgView";
import { AccountSettingsLoginAndSecurityView } from "./AccountSettingsLoginAndSecurityView";
import { AccountSettingsProfileView } from "./AccountSettingsProfileView";
import { AccountSettingsView } from "./AccountSettingsView";
import { AddPatientsView } from "./AddPatient/AddPatientsView";
import { AddProjectView } from "./AddProject/AddProjectView";
import { AdminAPIKeysListView } from "./AdminAPIKeysListView";
import { AdminDataSettingsView } from "./AdminDataSettingsView";
import { AdminOrganizationSettingsView } from "./AdminOrganizationSettingsView";
import { AdminPatientSettingsView } from "./AdminPatientSettingsView";
import { AdminResearchSettingsView } from "./AdminResearchSettingsView";
import { AdminUserListView } from "./AdminUserListView";
import { AdminView } from "./AdminView";
import { AdminWebhookDetailView } from "./AdminWebhookDetailView";
import { AdminWebhooksListView } from "./AdminWebhooksListView";
import { AppView } from "./AppView";
import { ClearIAL2LoginView } from "./ClearIAL2LoginView";
import { DesignSystemDemoView } from "./DesignSystemDemoView";
import { ExpiredPasswordView } from "./ExpiredPasswordView";
import { FacilitatedFHIRLoginView } from "./FacilitatedFHIRLoginView";
import { FastenCallbackView } from "./FastenCallbackView";
import { ForgotPasswordView } from "./ForgotPasswordView";
import { GlobalAdminAIPartnerEditView } from "./global-admin/GlobalAdminAIPartnerEditView";
import { GlobalAdminAIPartnersListView } from "./global-admin/GlobalAdminAIPartnersListView";
import { GlobalAdminReportsView } from "./global-admin/GlobalAdminReportsView";
import { GlobalAdminReportSchedulesView } from "./global-admin/GlobalAdminReportSchedulesView";
import { GlobalAdminReportCatalogueView } from "./global-admin/GlobalAdminReportCatalogueView";
import { GlobalAdminAnalyticsView } from "./global-admin/GlobalAdminAnalyticsView";
import { GlobalAdminBillingView } from "./global-admin/GlobalAdminBillingView";
import { GlobalAdminCreateUserView } from "./global-admin/GlobalAdminCreateUserView";
import { GlobalAdminDocumentRetrievalView } from "./global-admin/GlobalAdminDocumentRetrievalView";
import { GlobalAdminFeatureEnablementView } from "./global-admin/GlobalAdminFeatureEnablementView";
import { GlobalAdminGlobalOrganizationListView } from "./global-admin/GlobalAdminGlobalOrganizationsListView";
import { GlobalAdminHealthcareOrganizationLoginSettingsView } from "./global-admin/GlobalAdminHealthcareOrganizationLoginSettingsView";
import { GlobalAdminJobManagementView } from "./global-admin/GlobalAdminJobManagementView";
import { GlobalAdminManageOrganizationView } from "./global-admin/GlobalAdminManageOrganizationView";
import { GlobalAdminManageUserView } from "./global-admin/GlobalAdminManageUserView";
import { GlobalAdminMedAlliesView } from "./global-admin/GlobalAdminMedAlliesView";
import { GlobalAdminNewOrganizationView } from "./global-admin/GlobalAdminNewOrganizationView";
import { GlobalAdminOrgDetailView } from "./global-admin/GlobalAdminOrgDetailView";
import { GlobalAdminProjectsView } from "./global-admin/GlobalAdminProjectsView";
import { GlobalAdminQueueDetailView } from "./global-admin/GlobalAdminQueueDetailView";
import { GlobalAdminSkillEvalView } from "./global-admin/GlobalAdminSkillEvalView";
import { GlobalAdminUsersView } from "./global-admin/GlobalAdminUsersView";
import { GlobalAdminView } from "./global-admin/GlobalAdminView";
import { HealthcareOrganizationAnalyticsView } from "./HealthcareOrganizationAnalyticsView";
import { InformedConsentExperienceView } from "./InformedConsentExperienceView";
import { LegacyPatientRecordsDetailsRedirect } from "./LegacyPatientRecordsDetailsRedirect";
import { LoginFlowView } from "./LoginFlowView";
import { NamedRoutes } from "./NamedRoutes";
import { PatientConsentManagerView } from "./PatientConsentManagerView";
import { PatientCreateSmartLinkView } from "./PatientCreateSmartLinkView";
import { PatientDeleteMyAccountConfirmationView } from "./PatientDeleteMyAccountConfirmationView";
import { PatientDeleteMyAccountView } from "./PatientDeleteMyAccountView";
import { PatientDetailsHealthcareOrgView } from "./PatientDetailsHealthcareOrgView";
import { PatientLandingEmailCollectionView } from "./PatientLandingEmailCollectionView";
import { PatientLogoutView } from "./PatientLogoutView";
import { PatientRecordsView } from "./PatientRecordsView";
import { PatientResearchStudyDetailsView } from "./PatientResearchStudyDetailsView";
import { PatientSharingLinkDetailsView } from "./PatientSharingLinkDetailsView";
import { PatientsSearchView } from "./PatientsSearchView";
import { PatientStudiesListView } from "./PatientStudiesListView";
import { PatientsView } from "./PatientsView";
import { PatientSwitchOrganizationView } from "./PatientSwitchOrganizationView";
import { PatientTimelineDetailsView } from "./PatientTimelineDetailsView";
import { RecruitmentView } from "./RecruitmentView";
import { RedirectToPatientPortalEmbedView } from "./RedirectToPatientPortalEmbedView";
import { ResearcherStudiesDetailView } from "./ResearcherStudiesDetailView";
import { ResearchView } from "./ResearchView";
import { ResetPasswordView } from "./ResetPasswordView";
import { RouteErrorView } from "./RouteErrorView";
import { SiteStudyDetailsView } from "./SiteStudyDetailsView";
import { SocialLoginCallbackView } from "./SocialLoginCallbackView";
import { StudiesOverviewView } from "./StudiesOverviewView";
import { StudyManagerView } from "./StudyManagerView";
import { WelcomeBackOrgUserView } from "./WelcomeBackOrgUserView";
import { WelcomeBasicOrgDetailsView } from "./WelcomeBasicOrgDetailsView";
import { WelcomeCustomizeOrgDetailsView } from "./WelcomeCustomizeOrgDetailsView";
import { WelcomeOrgUserInviteView } from "./WelcomeOrgUserInviteView";
import { WelcomeUserDetailsView } from "./WelcomeUserDetailsView";
import { WelcomeUserView } from "./WelcomeUserView";
const t = getObservableT("common");
export function routingPaths(container) {
    return [
        {
            route: NamedRoutes.INDEX,
            path: "/",
            element: _jsx(AppView, { container: container }),
            errorElement: _jsx(RouteErrorView, { container: container }),
            children: [
                {
                    route: NamedRoutes.FORGOT_PASSWORD,
                    path: "forgot-password",
                    title: t("Forgot Password"),
                    element: _jsx(ForgotPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.EXPIRED_PASSWORD,
                    path: "expired-password/:userEmailAddress",
                    title: t("Expired Password"),
                    element: _jsx(ExpiredPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.RESET_PASSWORD,
                    path: "reset-password/:resetPasswordToken",
                    element: _jsx(ResetPasswordView, { container: container }),
                },
                {
                    route: NamedRoutes.DESIGN_SYSTEM_DEMO,
                    path: "design-system-demo",
                    element: _jsx(DesignSystemDemoView, {}),
                },
                {
                    route: NamedRoutes.ACCOUNT_SETTINGS,
                    path: "account-settings",
                    title: t("Account Settings"),
                    element: _jsx(AccountSettingsView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_PROFILE,
                            path: "profile",
                            title: t("Account Profile"),
                            element: _jsx(AccountSettingsProfileView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_LOGIN_AND_SECURITY,
                            path: "login-and-security",
                            title: t("Account Login And Security"),
                            element: _jsx(AccountSettingsLoginAndSecurityView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ACCOUNT_SETTINGS_ABOUT_YOUR_ORG,
                            path: "about-your-org",
                            title: t("Account About Your Organization"),
                            element: _jsx(AccountSettingsAboutYourOrgView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.HEALTHCARE_ORG_ANALYTICS,
                    path: "healthcare-organization-analytics",
                    title: t("Analytics"),
                    element: _jsx(HealthcareOrganizationAnalyticsView, { container: container }),
                },
                {
                    route: NamedRoutes.PROJECTS,
                    path: "projects",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PROJECTS,
                            title: t("Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.MY_PROJECTS,
                            path: "my-projects",
                            title: t("My Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.OTHER_PROJECTS,
                            path: "other-projects",
                            title: t("Other Projects"),
                            element: _jsx(ResearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_ADD_PROJECT,
                            path: ":projectId/add-project/:page?",
                            title: t("Add Project"),
                            element: _jsx(AddProjectView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD,
                            path: ":projectId/add-patients/:method?",
                            title: t("Add Patients"),
                            element: _jsx(AddPatientsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PROJECTS_PROJECT_MANAGER,
                            path: ":projectId",
                            element: _jsx(StudyManagerView, { container: container }),
                            children: [
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_ANALYTICS,
                                    path: "analytics",
                                    title: t("Project Analytics"),
                                    element: _jsx(StudiesOverviewView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_PATIENT_MANAGEMENT,
                                    path: "patient-management/:filter?",
                                    title: t("Project Patient Management"),
                                    element: _jsx(RecruitmentView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_DETAILS,
                                    path: "details",
                                    title: t("Project Details"),
                                    element: _jsx(ResearcherStudiesDetailView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.PROJECTS_PROJECT_MANAGER_PATIENT_EXPERIENCE,
                                    path: "patients-experience",
                                    title: t("Project Patient Experience"),
                                    element: _jsx(InformedConsentExperienceView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.PROJECTS_OTHER_DETAILS,
                            path: ":projectId/other-details",
                            title: t("Project Details"),
                            element: _jsx(SiteStudyDetailsView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENTS,
                    path: "patients",
                    title: t("Patients"),
                    element: _jsx(Outlet, {}),
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENTS,
                            title: t("Patients"),
                            element: _jsx(PatientsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENTS_SEARCH,
                            path: "search/:mrn",
                            title: t("Patients search"),
                            element: _jsx(PatientsSearchView, { container: container }),
                        },
                        {
                            route: NamedRoutes.PATIENTS_STUDY_DETAILS,
                            path: "patient-study-details/:studyId/:mrn",
                            title: t("Patient study details"),
                            element: _jsx(PatientDetailsHealthcareOrgView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_MY_HEALTHEX_LEGACY_REDIRECT,
                    path: "patient-my-healthex",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENT_MY_HEALTHEX_LEGACY_REDIRECT,
                            element: _jsx(Navigate, { to: "/patient-history", replace: true }),
                        },
                        {
                            route: NamedRoutes.PATIENT_MY_HEALTHEX_PROFILE_LEGACY_REDIRECT,
                            path: "profile",
                            element: _jsx(Navigate, { to: "/patient-history", replace: true }),
                        },
                        {
                            route: NamedRoutes.PATIENT_DELETE_MY_ACCOUNT_LEGACY_REDIRECT,
                            path: "delete-my-account",
                            element: _jsx(Navigate, { to: "/delete-my-account", replace: true }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_HOME,
                    path: "patient-home",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENT_HOME,
                            element: _jsx(Navigate, { to: "/patient-history", replace: true }),
                        },
                        {
                            route: NamedRoutes.PATIENT_MY_HEALTHEX_PROFILE,
                            path: "profile",
                            element: _jsx(Navigate, { to: "/patient-history", replace: true }),
                        },
                        {
                            route: NamedRoutes.PATIENT_HOME_DELETE_MY_ACCOUNT_LEGACY_REDIRECT,
                            path: "delete-my-account",
                            element: _jsx(Navigate, { to: "/delete-my-account", replace: true }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_DELETE_MY_ACCOUNT,
                    path: "delete-my-account",
                    title: t("Delete My Account"),
                    element: _jsx(PatientDeleteMyAccountView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_HISTORY,
                    path: "patient-history",
                    children: [
                        {
                            index: true,
                            indexForRoute: NamedRoutes.PATIENT_HISTORY,
                            element: _jsx(Navigate, { to: "/patient-records", replace: true }),
                        },
                        {
                            route: NamedRoutes.PATIENT_HISTORY_DETAILS,
                            path: "details/:recordType/:id",
                            element: _jsx(LegacyPatientRecordsDetailsRedirect, {}),
                        },
                    ],
                },
                {
                    route: NamedRoutes.PATIENT_RECORDS,
                    path: "patient-records/:section?",
                    title: t("Patient Records"),
                    element: _jsx(PatientRecordsView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_RECORDS_DETAILS,
                    path: "patient-records-details/:recordType/:id",
                    title: t("Records Details"),
                    element: _jsx(PatientTimelineDetailsView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_SHARING,
                    path: "patient-sharing/:section?",
                    title: t("Patient Sharing"),
                    element: _jsx(PatientStudiesListView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_SHARING_DETAILS,
                    path: "patient-sharing-details/:studyId",
                    title: t("Patient Sharing Details"),
                    element: _jsx(PatientResearchStudyDetailsView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CREATE_SMART_LINK,
                    path: "patient-create-smart-link",
                    title: t("Create share link"),
                    element: _jsx(PatientCreateSmartLinkView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_SMART_LINK_DETAILS,
                    path: ":shlId/patient-smart-link-details",
                    title: t("Share this link"),
                    element: _jsx(PatientSharingLinkDetailsView, { container: container }),
                },
                {
                    route: NamedRoutes.ADMIN,
                    path: "admin",
                    element: _jsx(AdminView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.ADMIN_ORG_SETTINGS,
                            path: "org-settings/:section?",
                            title: t("Admin"),
                            element: _jsx(AdminOrganizationSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_USERS,
                            path: "users",
                            element: _jsx(AdminUserListView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_APIKEYS,
                            path: "api-keys",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.ADMIN_APIKEYS,
                                    title: `${t("Admin")} | ${t("Manage API Keys")}`,
                                    element: _jsx(AdminAPIKeysListView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.ADMIN_WEBHOOKS,
                            path: "webhooks",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.ADMIN_WEBHOOKS,
                                    title: `${t("Admin")} | ${t("Webhooks")}`,
                                    element: _jsx(AdminWebhooksListView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.ADMIN_WEBHOOK_DETAIL,
                                    path: ":webhookId/:tab?",
                                    title: `${t("Admin")} | ${t("Webhook")}`,
                                    element: _jsx(AdminWebhookDetailView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.ADMIN_DATA_SETTINGS,
                            path: "data-settings/:section?",
                            title: `${t("Admin")} | ${t("Data Settings")}`,
                            element: _jsx(AdminDataSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_RESEARCH_SETTINGS,
                            path: "research-settings/:section?",
                            title: `${t("Admin")} | ${t("Research Settings")}`,
                            element: _jsx(AdminResearchSettingsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.ADMIN_PATIENT_SETTINGS,
                            path: "patient-settings/:section?",
                            title: `${t("Admin")} | ${t("Patient Settings")}`,
                            element: _jsx(AdminPatientSettingsView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.GLOBAL_ADMIN,
                    path: "global-admin",
                    element: _jsx(GlobalAdminView, { container: container }),
                    children: [
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_ORGANIZATIONS,
                            path: "organizations",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORGANIZATIONS,
                                    title: `${t("Global Admin")} | ${t("Organizations")}`,
                                    element: _jsx(GlobalAdminGlobalOrganizationListView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_CREATE,
                                    path: "data-originator/create",
                                    title: `${t("Global Admin")} | ${t("Create Healthcare Organization")}`,
                                    element: _jsx(GlobalAdminNewOrganizationView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL,
                                    path: "data-originator/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_DETAIL,
                                            title: `${t("Global Admin")} | ${t("Healthcare Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_LOGIN_SETTINGS,
                                            path: "login-settings",
                                            title: `${t("Global Admin")} | ${t("Login Settings")}`,
                                            element: _jsx(GlobalAdminHealthcareOrganizationLoginSettingsView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage Healthcare Organization Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USER_CREATE,
                                                    path: "create",
                                                    title: `${t("Global Admin")} | Create Healthcare Organization User`,
                                                    element: _jsx(GlobalAdminCreateUserView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("Healthcare Organization User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_ORIGINATOR_PROJECTS,
                                            path: "projects",
                                            title: `${t("Global Admin")} | ${t("Projects")}`,
                                            element: _jsx(GlobalAdminProjectsView, { container: container }),
                                        },
                                    ],
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_CREATE,
                                    path: "data-user/create",
                                    title: `${t("Global Admin")} | ${t("Create External Research Organization")}`,
                                    element: _jsx(GlobalAdminNewOrganizationView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL,
                                    path: "data-user/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_DETAIL,
                                            title: `${t("Global Admin")} | ${t("External Research Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage External Research Organization Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USER_CREATE,
                                                    path: "create",
                                                    title: `${t("Global Admin")} | Create External Research Organization User`,
                                                    element: _jsx(GlobalAdminCreateUserView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("External Research User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_DATA_USER_PROJECTS,
                                            path: "projects",
                                            title: `${t("Global Admin")} | ${t("Projects")}`,
                                            element: _jsx(GlobalAdminProjectsView, { container: container }),
                                        },
                                    ],
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL,
                                    path: "service-provider/:orgId",
                                    element: _jsx(GlobalAdminOrgDetailView, { container: container }),
                                    children: [
                                        {
                                            index: true,
                                            indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_DETAIL,
                                            title: `${t("Global Admin")} | ${t("Service Provider Organization Detail")}`,
                                            element: _jsx(GlobalAdminManageOrganizationView, { container: container }),
                                        },
                                        {
                                            route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USERS,
                                            path: "users",
                                            element: _jsx(Outlet, {}),
                                            children: [
                                                {
                                                    index: true,
                                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USERS,
                                                    title: `${t("Global Admin")} | ${t("Manage Service Provider Users")}`,
                                                    element: _jsx(GlobalAdminUsersView, { container: container }),
                                                },
                                                {
                                                    route: NamedRoutes.GLOBAL_ADMIN_ORG_SERVICE_PROVIDER_USER_DETAIL,
                                                    path: ":userId",
                                                    title: `${t("Global Admin")} | ${t("Service Provider User Detail")}`,
                                                    element: _jsx(GlobalAdminManageUserView, { container: container }),
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_REPORTS,
                            path: "reports",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_REPORTS,
                                    title: `${t("Global Admin")} | ${t("Reports")}`,
                                    element: _jsx(GlobalAdminReportsView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_REPORT_SCHEDULES,
                                    path: "schedules",
                                    title: `${t("Global Admin")} | ${t("Report Schedules")}`,
                                    element: _jsx(GlobalAdminReportSchedulesView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_REPORT_CATALOGUE,
                                    path: "available",
                                    title: `${t("Global Admin")} | ${t("Available Reports")}`,
                                    element: _jsx(GlobalAdminReportCatalogueView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_AI_PARTNERS,
                            path: "ai-partners",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_AI_PARTNERS,
                                    title: `${t("Global Admin")} | ${t("AI Partners")}`,
                                    element: _jsx(GlobalAdminAIPartnersListView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_AI_PARTNER_EDIT,
                                    path: "edit/:id",
                                    title: `${t("Global Admin")} | ${t("AI Partner Edit")}`,
                                    element: _jsx(GlobalAdminAIPartnerEditView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_AI_PARTNER_NEW,
                                    path: "new",
                                    title: `${t("Global Admin")} | ${t("AI Partner New")}`,
                                    element: _jsx(GlobalAdminAIPartnerEditView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_MEDALLIES,
                            path: "medallies",
                            title: `${t("Global Admin")} | ${t("MedAllies")}`,
                            element: _jsx(GlobalAdminMedAlliesView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_JOB_MANAGEMENT,
                            path: "jobs",
                            element: _jsx(Outlet, {}),
                            children: [
                                {
                                    index: true,
                                    indexForRoute: NamedRoutes.GLOBAL_ADMIN_JOB_MANAGEMENT,
                                    title: `${t("Global Admin")} | ${t("Job Management")}`,
                                    element: _jsx(GlobalAdminJobManagementView, { container: container }),
                                },
                                {
                                    route: NamedRoutes.GLOBAL_ADMIN_QUEUE_DETAIL,
                                    path: ":queueName",
                                    title: `${t("Global Admin")} | ${t("Queue Detail")}`,
                                    element: _jsx(GlobalAdminQueueDetailView, { container: container }),
                                },
                            ],
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_DOCUMENT_RETRIEVALS,
                            path: "retrievals",
                            title: `${t("Global Admin")} | ${t("Document Retrievals")}`,
                            element: _jsx(GlobalAdminDocumentRetrievalView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_FEATURE_ENABLEMENT,
                            path: "feature-enablement",
                            title: `${t("Global Admin")} | Feature Enablement`,
                            element: _jsx(GlobalAdminFeatureEnablementView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_SKILL_EVALUATIONS,
                            path: "skill-evaluations",
                            title: `${t("Global Admin")} | ${t("Skill Evaluations")}`,
                            element: _jsx(GlobalAdminSkillEvalView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_BILLING,
                            path: "billing",
                            title: `${t("Global Admin")} | ${t("Billing")}`,
                            element: _jsx(GlobalAdminBillingView, { container: container }),
                        },
                        {
                            route: NamedRoutes.GLOBAL_ADMIN_ANALYTICS,
                            path: "analytics",
                            title: `${t("Global Admin")} | ${t("Analytics")}`,
                            element: _jsx(GlobalAdminAnalyticsView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.LOGIN_SELECT,
                    path: "login-select/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_AS_ORG_USER,
                    path: "login/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_AS_PATIENT,
                    path: "login-patients/*",
                    element: _jsx(LoginFlowView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_AS_PATIENT_EMAIL_COLLECTION,
                    path: "login-patients-email-collection",
                    element: _jsx(PatientLandingEmailCollectionView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_SWITCH_ORG_AS_PATIENT,
                    path: "login-switch",
                    element: _jsx(PatientSwitchOrganizationView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGIN_REDIRECT_TO_EMBED,
                    path: "redirect-to-embed/:organizationId",
                    element: _jsx(RedirectToPatientPortalEmbedView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_ACCOUNT_DELETE_CONFIRMATION,
                    path: "patient-account-delete-confirmation",
                    title: t("Patient Account Delete Confirmation"),
                    element: _jsx(PatientDeleteMyAccountConfirmationView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
                    path: "patient-consent/:studyId/enrollment/:step?/:link?/:locationIndex?",
                    title: t("Patient Consent Enrollment"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_DATA_UPDATE,
                    path: "patient-consent/:studyId/data-update/:step?/:link?/:locationIndex?",
                    title: t("Patient Consent Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_RESUME,
                    path: "patient-consent/resume",
                    title: t("Patient Consent Resume"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_CONSENT_IDP_CALLBACK,
                    path: "patient-consent/idp-callback",
                    title: t("Patient Consent IdP Callback"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_CONSENT,
                    path: "patient-consent/ias/:step?/:link?/:locationIndex?",
                    title: t("Patient IAS Consent"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.PATIENT_IAS_DATA_UPDATE,
                    path: "patient-consent/ias-update/:step?/:link?/:locationIndex?",
                    title: t("Patient IAS Data Update"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
                    path: "guided-patient-consent/:studyId/:mrn/enrollment/:step?/:link?/:locationIndex?",
                    title: t("Guided Patient Consent Enrollment"),
                    element: _jsx(PatientConsentManagerView, { container: container }),
                },
                {
                    route: NamedRoutes.WELCOME,
                    path: "welcome",
                    children: [
                        {
                            route: NamedRoutes.WELCOME,
                            path: ":welcomeToken",
                            title: t("Getting Started"),
                            element: _jsx(WelcomeUserView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG,
                            path: "org/:welcomeOrgId",
                            title: t("Getting Started"),
                            element: _jsx(WelcomeUserView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG_USER_DETAILS,
                            path: "user-details",
                            title: t("User details"),
                            element: _jsx(WelcomeUserDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_BASIC_ORG_DETAILS,
                            path: "basic-org-details",
                            title: t("Basic Org Details"),
                            element: _jsx(WelcomeBasicOrgDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS,
                            path: "customize-org-details",
                            title: t("Customize Org Details"),
                            element: _jsx(WelcomeCustomizeOrgDetailsView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_ORG_USER_INVITE,
                            path: "invite-org-users",
                            title: t("Invite Org Users"),
                            element: _jsx(WelcomeOrgUserInviteView, { container: container }),
                        },
                        {
                            route: NamedRoutes.WELCOME_BACK_ORG_USER,
                            path: "welcome-back",
                            title: t("Welcome back"),
                            element: _jsx(WelcomeBackOrgUserView, { container: container }),
                        },
                    ],
                },
                {
                    route: NamedRoutes.ORG_LINK,
                    path: `${orgLinkPrefix}/:organizationId/*`,
                    element: _jsx(_Fragment, {}),
                },
                {
                    route: NamedRoutes.CLEAR_IAL2_CALLBACK,
                    path: "clear-ial2-callback",
                    element: _jsx(ClearIAL2LoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FACILITATED_FHIR_CALLBACK,
                    path: "epic-nexus/redirect",
                    element: _jsx(FacilitatedFHIRLoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FACILITATED_FHIR_OPEN_EPIC_CALLBACK,
                    path: "open-epic/redirect",
                    element: _jsx(FacilitatedFHIRLoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FACILITATED_FHIR_ECW_CALLBACK,
                    path: "ecw/redirect",
                    element: _jsx(FacilitatedFHIRLoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FACILITATED_FHIR_ORACLE_CALLBACK,
                    path: "oracle/redirect",
                    element: _jsx(FacilitatedFHIRLoginView, { container: container }),
                },
                {
                    route: NamedRoutes.FASTEN_CALLBACK,
                    path: "fasten-callback",
                    element: _jsx(FastenCallbackView, { container: container }),
                },
                {
                    route: NamedRoutes.SOCIAL_LOGIN_CALLBACK,
                    path: "social-login-callback",
                    element: _jsx(SocialLoginCallbackView, { container: container }),
                },
                {
                    route: NamedRoutes.LOGOUT_AS_PATIENT,
                    path: "logout-patient",
                    element: _jsx(PatientLogoutView, { container: container }),
                },
            ],
        },
    ];
}
